// store/authStore.js
import { create } from "zustand";
import { getTestimonial } from "../api/testimonial";

export const useTestimonialStore = create((set, get) => ({
    loading: true,
    testimonial: [],
    testimonialPage: null,
    getTestimonial: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getTestimonial()
            set({
                loading: false,
                testimonial: res?.ref,
                testimonialPage: res?.testimonialPage?.testimonial || null,
            })
            console.log("ref", res)
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }
}));
